import { v4 as uuidv4 } from "uuid";
export class StateSaveModel {
    constructor() {
        this.id = uuidv4();
        this.stateName = "";
        this.stateCode = "";
    }
}
export default class StateSave extends StateSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
